import { Component, Inject, Input, LOCALE_ID, OnInit, SimpleChanges } from '@angular/core';
import { ArticleService } from 'src/app/service/article.service';
import { OrderService } from 'src/app/service/order.service';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-currency-converter',
  templateUrl: './currency-converter.component.html',
  styleUrls: ['./currency-converter.component.scss']
})

//This ap-component takes in [data]={price: price, country: country}, country can be null to use user profile country
export class CurrencyConverterComponent implements OnInit {

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private articleServ: ArticleService,
    private orderServ: OrderService,
    private profileService: ProfileService
  ) { }
  @Input() data: any;
  currency: any;
  priceString: any;
  changeDetected: any;
  euro: any =
  {
    EUR_rate: "1.000000",
    currency: "EUR"
  }

  ngOnChanges(changes: SimpleChanges): void {
   if (changes.data && !changes.data.firstChange && this.currency != undefined) {
      if(this.data.country) {
        this.orderServ.getCurrencyRateByName(this.data.country).then((currency: any) => {
          if (currency.length >= 1) {
            this.currency = currency[0];
            this.setPriceString(this.currency);
          } else {
            this.setPriceString(this.euro);
          }
        });
      } 
      else{
        this.setPriceString(this.currency);
      }
    }
  }

  setPriceString(rate) {
    this.priceString = `${Math.round((this.data.price * rate.EUR_rate) * 100) / 100} ${rate.currency}`;
    return this.priceString
  }

  ngOnInit() {
    this.profileService.getUserProfilePromise().then((profile) => {
      const profileData = profile.data();
      if(this.data.country) {
        this.orderServ.getCurrencyRateByName(this.data.country).then((currency: any) => {
          if (currency.length >= 1) {
            this.currency = currency[0];
            this.setPriceString(this.currency);
          } else {
            this.setPriceString(this.euro);
          }
        });
      } 
      else {

        if (profileData.country){
          this.orderServ.getCurrencyRateByName(profileData.country).then((currency: any) => {
            if (currency.length >= 1) {
              this.currency = currency[0];
              this.setPriceString(this.currency);
            } 
            else {
              this.currency = this.euro
              this.setPriceString(this.euro);
            }
          });
        }
        else{
          this.currency = this.euro
          this.setPriceString(this.euro);
        }
      }
    });
  }

}
